import script from "./PhoneFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneFooter.vue?vue&type=script&setup=true&lang=js"

import "./PhoneFooter.vue?vue&type=style&index=0&id=74e40d34&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e40d34"]])

export default __exports__